import React from 'react';
import Chart from 'react-apexcharts';

const PieComponent = ({ chartData, domainCaptureChart, index }) => {

  const series = [
    (chartData.self * 100) / 7,
    (chartData.other * 100) / 7,
    (chartData.average * 100) / 7
  ];

  // const labels = ['Self', 'You', 'Company'];

  const options = {
    chart: {
      id: `pie-${index}`,
      background: '#f4f5fa',
      type: 'radialBar',
      animations: {
        enabled: false // 🔥 important for correct capture
      },
      events: {
        mounted: () => {
          setTimeout(() => {
            domainCaptureChart(`pie-${index}`, index);
          }, 1000);
        }
      }
    },
  
    colors: ['#ff349b', '#5599cc', '#ffbf32'], // ✅ FIXED
  
    fill: {
      type: 'solid',
      opacity: 1 // ✅ FIXED
    },
  
    stroke: {
      lineCap: "round",
      width: 2
    },
  
    plotOptions: {
      radialBar: {
        track: {
          background: '#fff',
        },
        startAngle: 0,
        endAngle: 270,
        hollow: {
          size: '25%',
        },
        dataLabels: {
          name: { show: false },
          value: { show: false }
        },
        barLabels: {
          enabled: true,
          useSeriesColors: true,
          fontSize: '13px',
          offsetX: -8, // Adjust this value
          offsetY: 0,
          formatter: function (seriesName, opts) {
            return seriesName + ": " + ((opts.w.globals.series[opts.seriesIndex]*7)/100).toFixed(1)
          },
        },
      },
    },
  
    labels: ['Self', 'You', 'Company']
  };

  return (
    <div className="custom-angle-circle-chart">
      <Chart options={options} series={series} type="radialBar" height={220} />
    </div>
  );
};

export default PieComponent;